import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SelectedSearchModel } from '@seahorse/common';
import { CollectionDisplay } from '../models/collection-display.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  currentModuleName = '';

  private searchResultCountSource = new Subject<number>();
  private searchSource = new Subject<SelectedSearchModel>();
  private selectedViewSource = new Subject<CollectionDisplay>();
  private openComponent = new Subject<void>();
  private selectedFilterSource = new Subject<any>();
  private toggleInactiveSource = new Subject<boolean>();

  searchChanged$ = this.searchSource.asObservable();
  searchResultCountChanged$ = this.searchResultCountSource.asObservable();
  selectedViewCalled$ = this.selectedViewSource.asObservable();
  openComponent$ = this.openComponent.asObservable();
  selectedFilterChanged$ = this.selectedFilterSource.asObservable();
  toggleInactiveChanged$ = this.toggleInactiveSource.asObservable();

  searchChanged(search: SelectedSearchModel) {
    this.searchSource.next(search);
  }

  searchResultCountChanged(count: number) {
    this.searchResultCountSource.next(count);
  }

  setSelectedView(view: CollectionDisplay) {
    this.selectedViewSource.next(Number(view));
  }

  open() {
    this.openComponent.next();
  }

  setSelectedFilter(filter: any) {
    this.selectedFilterSource.next(filter);
  }

  toggleInactiveAccounts(showInactive: boolean) {
    this.toggleInactiveSource.next(showInactive);
  }
}
